import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import {decode} from 'html-entities';
import ReactReadMoreReadLess from 'react-read-more-read-less'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import moment from "moment";
import { $ } from "react-jquery-plugin";
import { message } from "antd";
import { api, rules } from "../../apis/urls";


const CoachesView = () => {

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        EventViews();
    },[]
    );


    const { id } = useParams();
    const[ result,setResult ] = useState('');
    const[ testresult,setTestresult ] = useState('');
    const[ sportsresult,setSportsresult ] = useState('');
    
    const ruleid = localStorage.getItem("coachruleid")

    const coachid = localStorage.setItem("coachid",id);

    let navigate = useNavigate();


    const EventViews = ()=>{
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)
        const instance = axios.create({
            //baseURL: api+'rules/'+id,
            baseURL: rules+'/coach/'+id,
          
            timeout: 1000000,

            headers: {'authorization': token}
        });
        const data = {
            ruleid: ruleid
        };


        instance.post('',data).then(res => {
            setResult(res.data.data);
            setSportsresult(res.data);
            setTestresult(res.data);
           

          });

    }

    const handleSubmit = (itemid) => {

        console.log(itemid);

        let token = "Bearer "+localStorage.getItem('token');
        const data = {
           attemptid:itemid
        }
        

        const instance = axios.create({

            baseURL: rules+"/approvereattempt",

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.patch('',data).then((response) =>{

           

            if(response.data.message === "Success")
            {
                window.location.reload();
            }
           
          }).catch((error) =>{
            
        });

    }


    let sl=1;

    return(
       
    <div>
        <aside class="right-side areas">    
            <div class="content-area dash-contentss">

                <div className="page-title-wrpr">
                    <div className="page-title-left-column">
                        
                        <h2 className="page-title">Coach - {decode(`${result.firstname} ${result.lastname}`)}</h2>
                    </div>
                    <div className="page-rightside-action-column">
                        
                        
                    </div>
                
                
                </div>


                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li className="breadcrumb-item"><Link to={"/rule_coach/"+ruleid}>Coach List</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Coach View {decode(`${result.firstname} ${result.lastname}`)}</li>                    
                    </ol>
                </nav>

                <div>
                    <div class="containers" style={{overflow:'auto'}}>

                        <table class="table table-rules">
                            <thead>
                                <tr className="rules-table-head">
                                    <th scope="col">Name</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Phone</th>
                                    <th scope="col">Sports</th>
                                </tr>   
                            </thead>
                            <tbody className="rules-table-content">

                                <tr>
                                    <td>{decode(`${result.firstname} ${result.lastname}`)}</td>
                                    <td>{result.email}</td>     
                                    <td>{result.cell_phone}</td> 
                                    <td>
                                        {sportsresult.sportsDetails?.map((item, index) => (
                                        <tr>{decode(item.sportname)}</tr>
                                        ))}
                                    </td>
                                  
                                           
                                </tr>
                                    
                            </tbody>
                        </table>

                        { /* <table class="table table-rules">
                            <thead>
                                <tr className="rules-table-head">
                                    <th scope="col">Sl no.</th>
                                    <th scope="col">Date Attempt</th>
                                    <th scope="col">Score Attempt</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Answers</th>
                                </tr>   
                            </thead>
                            <tbody className="rules-table-content">

                                    {testresult.testdata?.map((item, index) =>(
                                        <tr>
                                            <td scope="row">{sl++}</td>
                                            <td>{item.attempted_date}</td>
                                            <td>{item.user_totalmarks}</td> 
                                            <td>{item.status}</td>
                                            
                                                              
                                        </tr>
                                    ))
                                }
                                {
                                    !testresult.testdata?
                                    (<div className="nodata">
                                        <h2>Sorry! No test found</h2>
                                    </div>):null
                    
                                }
                                    
                            </tbody>
                            </table> */ }
                    </div>
                </div>
                <div class="faculty-list-wrpr list-wrpr">
                    {testresult.testdata?(
                    testresult.testdata?.map((item, index) =>
                        <div class="list faculty">
                            <div class="row">
                                <div class="col-md-1">
                                    <div class="update-date">
                                        <span class="date-wrpr">{sl++}</span>
                                        <span class="desig">Sl.No</span>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="faculty-user">
                                        <span class="desig">Date Of Attempt</span>
                                        <span class="date-wrpr"> <td>{moment(item.attempted_date).format('MMMM DD, YYYY')}</td></span>

                                    </div>     
                                </div>
                                <div class="col-md-2">
                                    <div class="update-date">
                                        <span class="date-wrpr">{item.user_totalmarks} / {item.totalmarks}</span>
                                        <span class="desig">Score</span>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="update-date">
                                        <span class="date-wrpr">{item.status}</span>
                                        <span class="desig">Status</span>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="update-date" style={{display:'block'}}> 
                                        <button style={{ padding: "10px", background: '#4077c7', borderRadius: "5px", color: '#fff'}} 
                                            className="addbtnitem-link text-anchor" onClick={()=>{navigate("/coachanswers/"+item.id)}}
                                        >
                                            Answers
                                        </button>
                                    </div>
                                </div>
                                
                                
                               
                                
                            </div>  
                        </div>
                        
                        
                        )):null
                        }
                        {
                            !testresult.testdata?
                            (<div className="nodata">
                                <h2>Sorry! No Result Found</h2>
                            </div>):null
        
                        }

                </div> 
            </div>
        </aside>
    </div>








    )
}

export default CoachesView;